'use strict';

goog.provide("Ntry.JrHint");

Ntry.JrHint = function() {
    this._view = Ntry.interfaceManager.getDom('ntryHintArea');
    this._view.addClass('jrHintArea');
    this._currentIndex = 0;
    this._hints;
    this.createDom();
    this.aniPlay = true;
    this.mode = true;
};

(function(p){

    p.createDom = function () {
        var cm = Ntry.createElement;
        var that = this;
        var parent = this._view;

        var parent = cm('div', this._view , 'jrhintArea' ,null);
        // var parent_animation = cm('div', this._view , 'jrAnimationArea' , null);

        var header = cm('div', parent, null, 'jrHintHeader');
        this._hintNumber = cm('span', header, null, 'jrHintQuestionNumber');
        this._hintNumber.innerHTML = Lang.Menus.goals;
        var hintContainer = cm('span', header, null, 'jrHintContainer');
        this._hintContent = cm('table', hintContainer, null, 'jrHintContent');
        var tbody = cm('tbody', this._hintContent, null, 'tbody');
        var tr = cm('tr', tbody, null, 'tr');
        this._td = cm('td', tr, null, 'td');

        this._hintThumbnail = cm('div', parent, null, 'jrHintThumbnail');

        this._hintModal = cm('div', parent, null, 'ntryHintModal');
        this._hintModal.ntryRemove();

        this._hintModal.bindOnClick(function(e) {
            if (e.target == this) {
                e.stopPropagation();
                e.preventDefault();
                that._hintModal.ntryRemove();
            }
        });

        var modalContainer = Ntry.createElement('div', this._hintModal, null, 'jrHintModalContainer');
        var modalTitle = Ntry.createElement('div', modalContainer, null, 'ntryHintModalTitle')
        var modalText = Ntry.createElement('span', modalTitle, null, 'ntryModalTitleText');
        modalText.innerHTML = Lang.Menus.help;
        this._closeButton = Ntry.createElement('span', modalTitle, null, 'ntryHintModalCloseButton');
        this._modalContent = Ntry.createElement('div', modalContainer, null, 'jrHintModalContent');
        //this._closeButton = Ntry.createElement('span', this._modalContent, null, 'jrHintModalCloseButton');

    };

    p.initmode = function(mode) {
        document.getElementById('jrhintArea').style.display = 'block';
        document.getElementById('jrAnimationArea').style.display = 'none';
    };

    p.update = function() {
    };

    p.loadConfig = function () {
        var con = Ntry.configManager;
        this.position();
        this._hints = con.getConfig('hints');
        this.fillHintContent();
    };

    p.showPlayAnimationMode = function() {}

    p.fillAnimationContent = function(next) {
        var step =  next==undefined ? 0 : next;
        var text = this._hints[0].text;
        this.header_content.innerHTML = text[step];
    };

    p.fillHintContent = function () {
        var hint =  this._hints[0];
        this._td.innerHTML = hint.content;
        var image = hint.image;

        if (image) {
            this._hintThumbnail.removeClasses();
            this._hintThumbnail.addClass("jrHintThumbnail");
            this._hintThumbnail.addClass("jrHintThumbnail_"+image);
            if (image == 1 || image == 11)
                this._hintThumbnail.addClass(Lang.type);

            this._modalContent.removeClasses();
            this._modalContent.addClass("jrHintModalImage");
            this._modalContent.addClass("jrHintModalImage_"+image);
            if (image == 1 || image == 11)
                this._modalContent.addClass(Lang.type);

            var self = this;
            this._hintThumbnail.bindOnClick(function(e) {
                e.stopPropagation();
                e.preventDefault();
                self._hintModal.ntryShow();
            });
            this._closeButton.bindOnClick(function() {
                self._hintModal.ntryRemove();
            });
        }

    };

    p.position = function() {
        var gridSize = Ntry.configManager.getConfig("gridSize");
        var tileSize = Ntry.configManager.getConfig("tileSize");
        var engineHeight = $(Ntry.interfaceManager.getDom('ntryEngine')).height();
        var adjust = gridSize.height > 3 ? 1/gridSize.width*7 : 1;
        var top = gridSize.height*tileSize*adjust + engineHeight + 13;
        $(this._view).css('top', top+'px');
    };

})(Ntry.JrHint.prototype);
